// src/locales/si/stockAdjustment.js
export const stockAdjustment = {
  // Page titles
  createStockAdjustment: 'ස්ටොක් සකස් කිරීමක් සාදන්න',
  editStockAdjustment: 'ස්ටොක් සකස් කිරීම සංස්කරණය කරන්න',
  stockAdjustmentDetails: 'ස්ටොක් සකස් කිරීමේ විස්තර',
  backToStockAdjustments: 'ස්ටොක් සකස් කිරීම් වෙත ආපසු යන්න',
  allStockAdjustments: 'සියලු ස්ටොක් සකස් කිරීම්',
  pageDescription: 'ගබඩා අසමතුලිතතා සඳහා ස්ටොක් මට්ටම් සකස් කරන්න',
  detailsPageDescription: 'ස්ටොක් සකස් කිරීමේ විස්තර බලන්න සහ කළමනාකරණය කරන්න',

  // Form sections
  selectWarehouse: 'ගබඩාව තෝරන්න',
  addItems: 'අයිතම එකතු කරන්න',
  adjustmentItems: 'සකස් කළ අයිතම',

  // Warehouse selection
  warehouse: 'ගබඩාව',
  warehouseRequired: 'ගබඩාව අවශ්‍යයි',
  selectWarehousePlaceholder: 'ගබඩාව තෝරන්න',
  allWarehouses: 'සියලු ගබඩා',

  // Existing adjustments dialog
  existingAdjustments: 'පවතින කෙටුම්පත් සකස් කිරීම්',
  existingAdjustmentsMessage: 'ඔබට අද දිනට පවතින කෙටුම්පත් සකස් කිරීම් ඇත. ඔබට කිරීමට අවශ්‍ය දේ කුමක්ද?',
  continueWith: 'ඒ සමග ඉදිරියට යන්න',
  startNewAdjustment: 'නව සකස් කිරීමක් ආරම්භ කරන්න',
  selectAdjustment: 'සකස් කිරීම තෝරන්න',

  // Product search
  searchProducts: 'නිෂ්පාදන සෙවීම',
  searchProductsPlaceholder: 'නම, SKU, හෝ බාර්කෝඩ් අනුව සොයන්න...',
  noProductsFound: 'නිෂ්පාදන හමු නොවුණි',
  searchingProducts: 'සොයමින්...',
  currentStock: 'වත්මන් ස්ටොක්',
  searchItems: 'අයිතම සොයන්න...',
  searchPlaceholder: 'සකස් කිරීමේ අංකය අනුව සොයන්න...',

  // Add item form
  addItemTitle: 'අයිතමයක් සකස් කිරීමට එකතු කරන්න',
  editItemTitle: 'සකස් කළ අයිතම සංස්කරණය කරන්න',
  productName: 'නිෂ්පාදනය',
  recordedCount: 'ලියාපදිංචි ප්‍රමාණය',
  physicalCount: 'භෞතික ප්‍රමාණය',
  physicalCountRequired: 'භෞතික ප්‍රමාණය අවශ්‍යයි',
  physicalCountMinimum: 'භෞතික ප්‍රමාණය 0 හෝ ඊට වඩා වැඩි විය යුතුය',
  variance: 'විචලනය',
  notes: 'සටහන්',
  notesPlaceholder: 'මෙම අයිතමය සඳහා සටහන් එක් කරන්න...',
  addItem: 'අයිතමය එක් කරන්න',
  updateItem: 'අයිතමය යාවත්කාලීන කරන්න',
  cancel: 'අවලංගු කරන්න',

  // Items table
  itemNumber: '#',
  itemProduct: 'නිෂ්පාදනය',
  itemRecordedCount: 'ලියාපදිංචි',
  itemPhysicalCount: 'භෞතික',
  itemVariance: 'විචලනය',
  itemNotes: 'සටහන්',
  itemActions: 'ක්‍රියාමාර්ග',
  edit: 'සංස්කරණය',
  delete: 'මකන්න',

  // Summary
  totalItems: 'එකතුව අයිතම',
  totalVariance: 'මුළු විචලනය',
  noItemsAdded: 'තවම අයිතම එකතු කර නැත',
  addItemsToAdjustment: 'මෙම ස්ටොක් සකස් කිරීමට අයිතම සෙවීම සහ එකතු කිරීම කරන්න',
  items: 'අයිතම',
  item: 'අයිතමය',
  ofItems: 'අයිතම {{total}} න්',

  // Actions
  finalizeAdjustment: 'සකස් කිරීම අවසන් කරන්න',
  confirmFinalize: 'අවසන් කිරීමෙන් ස්ටොක් මට්ටම් ස්ථිරව යාවත්කාලීන වනු ඇත. මෙය ආපසු හැරවිය නොහැක. ඔබට දිගටම යාමට අවශ්‍යද?',
  confirmFinalizeTitle: 'ස්ටොක් සකස් කිරීම අවසන් කරන්න',
  confirmDelete: 'මෙම අයිතමය ඉවත් කිරීමට ඔබට අවශ්‍යද?',
  finalize: 'අවසන් කරන්න',
  print: 'මුද්‍රණය කරන්න',
  exportCSV: 'CSV වෙත නිර්යාත කරන්න',

  // Status messages
  adjustmentCreated: 'ස්ටොක් සකස් කිරීම {{adjustmentNumber}} සාර්ථකව සාදන ලදි',
  itemAdded: 'අයිතමය සාර්ථකව එකතු කරන ලදි',
  itemUpdated: 'අයිතමය සාර්ථකව යාවත්කාලීන කරන ලදි',
  itemDeleted: 'අයිතමය සාර්ථකව ඉවත් කරන ලදි',
  adjustmentFinalized: 'ස්ටොක් සකස් කිරීම අවසන් කර ස්ටොක් යාවත්කාලීන කරන ලදි',
  duplicateItem: 'මෙම නිෂ්පාදනය දැනටමත් මෙම සකස් කිරීමේ එක් කර ඇත',

  // Error messages
  failedToLoadWarehouses: 'ගබඩා පූරණය අසාර්ථක විය',
  failedToLoadAdjustments: 'ස්ටොක් සකස් කිරීම් පූරණය අසාර්ථක විය',
  failedToSearchProducts: 'නිෂ්පාදන සෙවීම අසාර්ථක විය',
  failedToAddItem: 'අයිතම එකතු කිරීම අසාර්ථක විය',
  failedToUpdateItem: 'අයිතම යාවත්කාලීන කිරීම අසාර්ථක විය',
  failedToDeleteItem: 'අයිතම මැකීම අසාර්ථක විය',
  failedToFinalize: 'සකස් කිරීම අවසන් කිරීම අසාර්ථක විය',
  noItemsToFinalize: 'අවසන් කිරීමට පෙර අවම වශයෙන් එක අයිතමයක් එකතු කරන්න',
  failedToLoad: 'ස්ටොක් සකස් කිරීම පූරණය අසාර්ථක විය',
  adjustmentNotFound: 'ස්ටොක් සකස් කිරීම හමු නොවුණි',
  goBackToList: 'ලැයිස්තුවට ආපසු යන්න',

  // Validation
  pleaseSelectWarehouse: 'කරුණාකර පළමුව ගබඩාව තෝරන්න',
  atLeastOneItemRequired: 'අවම වශයෙන් එක අයිතමයක් අවශ්‍යයි',

  // Loading states
  loadingWarehouses: 'ගබඩා පූරණය වෙමින්...',
  loadingAdjustments: 'ස්ටොක් සකස් කිරීම් පූරණය වෙමින්...',
  loadingProducts: 'නිෂ්පාදන පූරණය වෙමින්...',
  addingItem: 'අයිතම එකතු කරමින්...',
  updatingItem: 'අයිතම යාවත්කාලීන කරමින්...',
  deletingItem: 'අයිතම මකාමින්...',
  finalizing: 'සකස් කිරීම අවසන් කරමින්...',
  loadingDetails: 'සකස් කිරීමේ විස්තර පූරණය වෙමින්...',

  // Adjustment info
  adjustmentNumber: 'සකස් කිරීමේ අංකය',
  adjustmentDate: 'සකස් කිරීමේ දිනය',
  createdBy: 'නිර්මාණය කළා',
  finalizedBy: 'අවසන් කළා',
  status: 'තත්ත්වය',
  statusDraft: 'කෙටුම්පත',
  statusFinalized: 'අවසන් කළා',
  allStatuses: 'සියලු තත්ත්වයන්',

  // Keyboard shortcuts
  keyboardShortcuts: 'යතුරු පුවරු කෙටිමං',
  focusSearch: 'සෙවීම මත කේන්ද්‍රීකරණය කරන්න',
  clearSearch: 'සෙවීම මකන්න',
  submitForm: 'පෝරමය ඉදිරිපත් කරන්න',

  // Variance display
  variancePositive: 'අතිරික්තය',
  varianceNegative: 'අඩුව',
  varianceZero: 'වෙනස්කමක් නැත',

  // Common
  sku: 'SKU',
  barcode: 'බාර්කෝඩ්',
  quantity: 'ප්‍රමාණය',
  loading: 'පූරණය වෙමින්...',
  save: 'සුරකින්න',
  close: 'වසන්න',
  confirm: 'තහවුරු කරන්න',
  confirmAction: 'අවසන් කිරීම තහවුරු කරන්න',
  yes: 'ඔව්',
  no: 'නැහැ',
  total: 'එකතුව',
  unknownProduct: 'නොදන්නා නිෂ්පාදනය',
  noMatch: 'අදාළ නැත',
  recorded: 'ලියාපදිංචි',
  physical: 'භෞතික',
  product: 'නිෂ්පාදනය',
  addedOn: 'එක් කළ දිනය',
  tryAdjustingSearch: 'ඔබේ සෙවීමේ පරාමිතිය වෙනස් කර බලන්න',
  dateRange: 'දිනයේ පරාසය',

  // Empty states
  noAdjustmentsFound: 'ස්ටොක් සකස් කිරීම් හමු නොවුණි',
  noAdjustmentsFoundDescription: 'ඔබේ වත්මන් පෙරහන් වලට ගැලපෙන සකස් කිරීම් නොමැත. කරුණාකර සෙවීම වෙනස් කරන්න.',
  noAdjustmentsYet: 'තවමත් ස්ටොක් සකස් කිරීම් නොමැත',
  noAdjustmentsYetDescription: 'ගබඩා අසමතුලිතතා නිරීක්ෂණය කිරීමට ඔබේ පළමු ස්ටොක් සකස් කිරීම සාදන්න.',
  createFirstAdjustment: 'පළමු ස්ටොක් සකස් කිරීම සාදන්න',
};
